import type { NuxtApp } from "nuxt/app";

export function getGa4ClientId(nuxtApp: NuxtApp): string {
  const cookie = getCookie(nuxtApp, "_ga");

  if (cookie !== null) {
    return cookie.split(".").slice(-2).join(".");
  }

  return "";
}

export function getGa4SessionIds(
  nuxtApp: NuxtApp,
  ga4MeasurementId: string,
): string[] {
  if (!ga4MeasurementId) return [];

  const cookie = getCookie(
    nuxtApp,
    `_ga_${ga4MeasurementId.replace("G-", "")}`,
  );

  if (cookie !== null) {
    return cookie.split(".").slice(2, 4);
  }

  return [];
}

/**
 * Get cookie value by name from the client or server.
 * If you are in the nuxt context already (i.e. `script setup` of a component or a nuxt plugin), you can use Nuxt's default `useCookie` composable instead.
 */
function getCookie(nuxtApp: NuxtApp, name: string): string | null {
  const cookieString = import.meta.client
    ? document.cookie
    : nuxtApp.ssrContext?.event.node.req.headers.cookie;

  if (!cookieString) return null;

  const nameLenPlus = name.length + 1;

  return (
    cookieString
      .split(";")
      .map((c) => c.trim())
      .filter((cookie) => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map((cookie) => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || null
  );
}

export function getFbp(nuxtApp: NuxtApp): string {
  return getCookie(nuxtApp, "_fbp") ?? "";
}

export function getFbc(nuxtApp: NuxtApp): string {
  return getCookie(nuxtApp, "_fbc") ?? "";
}

export function getGoogleClickId(): string {
  let googleClickId: string | null = "";

  // @todo fix this for ssr
  if (import.meta.server) return "";

  try {
    googleClickId = localStorage.getItem("gclid");
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error);
  }

  return googleClickId !== null ? googleClickId : "";
}
